import { DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactNode } from "react";
import { styled } from "styled-components";


export interface DialogTitleProps {
    id: string;
    children?: ReactNode;
    onClose: () => void;
    customTheme: any;
}

const BootstrapDialogTitleStyle = styled('div')`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    
    h3 {
        font-size: ${({theme}) => theme.font.large};
        font-family: Roboto, Helvetica, Arial, sans-serif;
        font-size: 1rem;
        line-height: 1.5;
        letter-spacing: 0.00938em;
        font-weight: 700;
        padding: 0;
        display: flex;
        align-items: center;
    }
`;


export function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, customTheme, ...other } = props;
  
    return (
      <BootstrapDialogTitleStyle className="px-4 py-2">
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            className="p-0"
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </BootstrapDialogTitleStyle>
    );
}